module.exports = __webpack_public_path__ + "static/media/webiq.46b6e870.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners-hover/webiq.png
// module id = 839
// module chunks = 1